import axios from "axios";

export const host = process.env.REACT_APP_API_URL;
//export const host = "http://localhost:17072/api/v1"; //로컬(개발DB)
//export const host = "http://localhost:27072/api/v1"; //로컬(운영DB)
//export const host = "http://110.45.199.220:27070/api/v1"; //운영서버(107번 공인IP)
//export const host = "http://121.254.145.232:27070/api/v1"; //이중화 L4서버(105q번 공인IP)

function post(request, body) {
    return axios.post(request, body);
}

function postQueryString(request, config) {
    return axios.post(request, null, config);
}

function get(request, body) {
    return axios.get(request, {
        params: body
    })
}

function put(request, body) {
    return axios.put(request, body);
}

function patch(request, body) {
    return axios.patch(request, body);
}0

function deleteM(request, body) {
    return axios.delete(request, {data: body});
}

export function acceptLogin(params) {
    const request = host + "/login/";
    return get(request, params);
}

export function account(accountId, password) {
    const request = host + "/user/login/" + accountId + "/" + password;
    return get(request);
}

export function getStore(storeCd) {
    const request = host + "/store/" + storeCd;
    return get(request);
}

export function getStoreWhere(params) {
    const request = host + "/store/where";
    return get(request, params);
}

export function getProductList(params) {
    const request = host + "/product/ckpos/getCkProductList";
    return post(request, params);
}

export function getProductListByAll(params) {
    const request = host + "/product/ckpos/getProductListByAll";
    return get(request, params);
}

export function getCompany(cmpCd) {
    const request = host + "/company/" + cmpCd;
    return get(request);
}

export function getCompanyList(params) {
    const request = host + "/company/list";
    return get(request, params);
}

export function getBrand(cmpCd, brandCd) {
    const request = host + "/brand/" + cmpCd + "/" + brandCd;
    return get(request);
}

export function getBrandList(cmpCd) {
    const request = host + "/brand/list/" + cmpCd;
    return get(request);
}

export function getBrandSearch(params) {
    const request = host + "/brand/search?cmpCd=" + params.cmpCd + "&brandCd=" + params.brandCd;
    return post(request, params);
}

export function getBrandListStoreCnt(params) {
    const request = host + "/brand/search";
    return get(request, params);
}

export function putBrand(params) {
    const request = host + '/brand/put';
    return put(request, params);
}

export function getStoreCorner(params) {
    const request = host + "/store/corner/list";
    return get(request, params);
}

export function getStoreVan(params) {
    const request = host + "/store/getStoreVanList?cmpCd=" + params.cmpCd + "&brandCd=" + params.brandCd + "&storeCd=" + params.storeCd;
    return post(request, params);
}

export function putStore(store) {
    const request = host + '/store/put';
    return put(request, store);
}

export function putStoreCorner(cornerList) {
    const request = host + "/store/corner";
    return put(request, cornerList);
}

export function putStoreVan(storeVan) {
    const request = host + "/store/van/term";
    return put(request, storeVan);
}

export function deleteStoreCorner(cornerList) {
    const request = host + "/store/corner";
    return deleteM(request, cornerList);
}

export function getCurrentDay(params) {
    const request = host + "/ck/sale/currentDay";
    return post(request, params);
}

export function getDailySales(params) {
    const request = host + "/ck/sale/daily";
    return post(request, params);
}

export function getDailyHourlySales(params) {
    const request = host + "/ck/sale/dailyHourlySale";
    return post(request, params);
}

export function getMonthlySales(params) {
    const request = host + "/ck/sale/monthly";
    return post(request, params);
}

export function getBbsBulletin(params) {
    const request = host + "/bbs/list";
    return get(request, params);
}

export function getPosUserList(params) {
    const request = host + "/pos/getPosUserList";
    return get(request, params);
}

export function getErestSimpleStockList(params) {
    const request = host + "/stock/getErestSimpleStockList";
    return get(request, params);
}

export function getProductMappingList(params) {
    const request = host + "/product/ckpos/getCkProuctMappingList";
    return get(request, params);
}

export function putProductMapping(params) {
    const request = host + "/product/ckpos/putCkProductMapping";
    return put(request, params);
}

export function getSaleWebCloseReport(params) {
    const request = host + "/ck/sale/getSaleWebCloseReport";
    return get(request, params);
}

export function getBcmpSaleReport(params) {
    const request = host + "/ck/sale/getBcmpSaleReport";
    return get(request, params);
}

export function getDailyStoreSaleReport(params) {
    const request = host + "/ck/sale/getDailyStoreSaleReport";
    return get(request, params);
}

export function putProduct(params) {
    const request = host + "/product/ckpos/put";
    return put(request, params);
}

export function getProductByRestProductCd(params) {
    const request = host + '/product/getProductByRestProductCd';
    return get(request, params);
}

export function getProductByRest(params) {
    const request = host + "/product/ckpos/getProductByRest";
    return get(request, params);
}

export function getProductByStore(params) {
    const request = host + "/product/ckpos/getProductByStore";
    return get(request, params);
}

export function getProductByCorner(params) {
    const request = host + "/product/ckpos/getProductByCorner";
    return get(request, params);
}

export function getRestProduct(params) {
    const request = host + "/product/ckpos/getRestProduct";
    return get(request, params);
}


export function insertProductStore(params) {
    const request = host + "/product/ckpos/insertProductStore";
    return put(request, params);
}

export function deleteProductStore(params) {
    const request = host + "/product/ckpos/deleteProductStore";
    return deleteM(request, params);
}

export function updateProductStore(params) {
    const request = host + "/product/ckpos/updateProductStore";
    return put(request, params);
}

export function uploadProductStore(params) {
    const request = host + "/product/ckpos/uploadProductStore";
    return put(request, params);
}

export function putStockList(params) {
    const request = host + "/stock/putList";
    return put(request, params);
}

export function putSaleSpct(params) {
    const request = host + "/rest/putSaleSpct";
    return put(request, params);
}

export function getCloseDailySale(params) {
    const request = host + "/ck/sale/closeDailySale";
    return post(request, params);
}

export function getCurrentDayStats(params) {
    const request = host + "/ck/sale/currentDayStats";
    return post(request, params);
}

export function getBillSaleDetail(params) {
    const request = host + '/ck/sale/currentDayBillDetail';
    return post(request, params);
}

export function getStoreDevice(params) {
    const request = host + '/store/pos/list';
    return get(request, params);
}

export function getStoreKitchenPrtInfo(params) {
    const request = host + '/store/kitchen/getStoreKitchenPrt';
    return post(request, params);
}

export function putStoreDevice(params) {
    const request = host + "/store/pos/putStoreDevice";
    return put(request, params);
}

export function getStoreDeviceInfo(params) {
    const request = host + '/store/pos/device';
    return get(request, params);
}

export function getPrtList(params) {
    const request = host + '/store/kitchen/getPrtList';
    return post(request, params);
}

export function getPosPrtMap(params) {
    const request = host + '/store/kitchen/getPosPrtMap';
    return post(request, params);
}

export function putPosPrtMap(params) {
    const request = host + '/store/kitchen/putPosPrtMap';
    return put(request, params);
}

export function getStoreKitchenProduct(params) {
    const request = host + '/store/kitchen/getStoreKitchenProduct';
    return post(request, params);
}

export function putStorePrtProduct(params) {
    const request = host + '/store/kitchen/putStorePrtProduct';
    return put(request, params);
}

export function putStorePrt(params) {
    const request = host + '/store/kitchen/putStorePrt';
    return put(request, params);
}

export function delStoreKitchenPrt(params) {
    const request = host + '/store/kitchen/delStoreKitchenPrt';
    return put(request, params);
}

export function updateKitchenProduct(params) {
    const request = host + '/store/kitchen/updateKitchenProduct';
    return put(request, params);
}


export function getCornerSale(params) {
    const request = host + '/ck/sale/cornerSale';
    return post(request, params);
}

export function getCornerSaleDaily(params) {
    const request = host + '/ck/sale/cornerSaleDaily';
    return post(request, params);
}

export function getCornerSaleMonthly(params) {
    const request = host + '/ck/sale/cornerSaleMonthly';
    return post(request, params);
}

export function getCornerSaleHourly(params) {
    const request = host + '/ck/sale/cornerSaleHourly';
    return post(request, params);
}

export function getCornerSaleHourlyDetail(params) {
    const request = host + '/ck/sale/cornerSaleHourlyDetail';
    return post(request, params);
}

export function getRejectSaleStats(params) {
    const request = host + '/ck/sale/rejectSaleStats';
    return post(request, params);
}

export function getRejectDailySale(params) {
    const request = host + '/ck/sale/rejectDailySale';
    return post(request, params);
}

export function getRejectCurrentDaySale(params) {
    const request = host + '/ck/sale/rejectCurrentDaySale';
    return post(request, params);
}

export function getRejectProductSale(params) {
    const request = host + '/ck/sale/rejectProductSale';
    return post(request, params);
}

export function getRejectCornerSale(params) {
    const request = host + '/ck/sale/rejectCornerSale';
    return post(request, params);
}

export function getDetailCurrentDaySaleHd(seq) {
    const request = host + '/ck/sale/detailCurrentDaySaleHd/' + seq;
    return get(request);
}

export function getDetailCurrentDaySaleDt(seq) {
    const request = host + '/ck/sale/detailCurrentDay/' + seq;
    return get(request);
}

export function getDetailCurrentDaySaleSt(seq) {
    const request = host + '/ck/sale/detailCurrentDayPay/' + seq;
    return get(request);
}

export function getPosUserListByStore(params) {
    const request = host + '/user/store/user-list';
    return get(request, params);
}

export function getUserList(params) {
    const request = host + '/user/store/userList';
    return post(request, params);
}

export function getPosConfig(params) {
    const request = host + '/config/form';
    return get(request, params);
}

export function getPosConfigData(params) {
    const request = host + '/config/form/data';
    return get(request, params);
}

export function patchPosConfig(params) {
    const request = host + '/config/config-infos';
    return patch(request, params);
}

export function mergePosConfig(params) {
    const request = host + '/config/merge';
    return post(request, params);
}

export function getCommonCodeGroup(params) {
    const request = host + '/common/group';
    return get(request, params);
}

export function getPeriodProductSale(params) {
    const request = host + '/ck/sale/periodProductSale';
    return post(request, params);
}

export function getCkProductListNation(params) {
    const request = host + '/product/ckpos/getCkProductListNation';
    return get(request, params);
}

export function insertCkProductInfo(params) {
    const request = host + "/product/ckpos/insertCkProductInfo";
    return put(request, params);
}

export function getCkProductInfoOne(params) {
    const request = host + '/product/ckpos/getCkProductInfoOne';
    return get(request, params);
}

export function putPosUser(params) {
    const request = host + '/user/';
    //const request = host + '/user/putPosUser';
    return put(request, params);
}


export function getCardApprSale(params) {
    const request = host + '/ck/sale/cardApprSale';
    return post(request, params);
}

export function getCardApprSaleDetail(params) {
    const request = host + '/ck/sale/cardApprDetailSale';
    return post(request, params);
}

export function getCardCompanyApprSaleDetail(params) {
    const request = host + '/ck/sale/cardCompanyApprSaleDetail';
    return post(request, params);
}

export function getCashApprSaleDetail(params) {
    const request = host + '/ck/sale/cashApprSaleDetail';
    return post(request, params);
}


export function getCardCompanyApprSale(params) {
    const request = host + '/ck/sale/cardCompanyApprSale';
    return post(request, params);
}

export function getCashApprSale(params) {
    const request = host + '/ck/sale/cashApprSale';
    return post(request, params);
}

export function putProductPrice(params) {
    const request = host + "/product/ckpos/putProductPrice";
    return put(request, params);
}

export function getPeriodWeeklySale(params) {
    const request = host + '/ck/sale/periodWeeklySale';
    return post(request, params);
}

export function getAuthority(params) {
    const request = host + '/common/authority';
    return get(request, params);
}

export function getProductExpire(params) {
    const request = host + "/product/ckpos/getProductExpire";
    return get(request, params);
}

export function putProductExpire(params) {
    const request = host + "/product/ckpos/putProductExpire";
    return put(request, params);
}




export function requestStore(params) {
    const request = host + '/store/requestStore';
    return get(request, params);
}

export function getCkProductBrandMappingList(params) {
    const request = host + '/product/ckpos/product/getCkProductBrandMappingList';
    return post(request, params);
}

export function getCkProductBrandMultiMappingList(params) {
    const request = host + '/product/ckpos/product/getCkProductBrandMultiMappingList';
    return post(request, params);
}

export function updateProductBrandMapping(params) {
    const request = host + '/product/ckpos/updateProductBrandMapping';
    return post(request, params);
}

export function deleteProductBrandMapping(params) {
    const request = host + '/product/ckpos/deleteProductBrandMapping';
    return post(request, params);
}

export function updateStoreDataCopy(params) {
    const request = host + '/store/updateStoreDataCopy';
    return post(request, params);
}

export function getMaxBillNo(params) {
    const request = host + '/sale/tr/getMaxBillNo';
    return post(request, params);
}

export function putSaleData(params) {
    const request = host + '/sale/put';
    return put(request, params);
}

export function getCkProductMappingBySourceCd(params) {
    const request = host + '/product/ckpos/getCkProductMappingBySourceCd';
    return get(request, params);
}

export function deleteSaleData(params) {
    const request = host + '/ck/sale/deleteSaleData';
    return post(request, params);
}

export function getProductPrice(params) {
    const request = host + "/product/ckpos/getProductPrice";
    return get(request, params);
}

export function getMenuList(params) {
    const request = host + "/menu/getMenuList";
    return get(request, params);
}

export function putMenu(params) {
    const request = host + "/menu/putMenu";
    return put(request, params);
}

export function getUserMenuList(params) {
    const request = host + "/menu/getUserMenuList";
    return get(request, params);
}

export function putUserMenu(params) {
    const request = host + "/menu/putUserMenu";
    return put(request, params);
}

export function deleteUserMenu(params) {
    const request = host + "/menu/deleteUserMenu";
    return deleteM(request, params);
}

export function getFloorList(storeCd) {
    const request = host + "/table/" + storeCd + "/floors";
    return get(request);
}

export function getProductStockDetail(params) {
    const request = host + "/stock/getProductStockDetail";
    return get(request, params);
}

export function putSaleCl(params) {
    const request = host + '/ck/sale/putSaleCl';
    return put(request, params);
}

